<template>
  <section class="auth-form">
    <div class="auth-form__container">
      <AuthenticationBackground />
      <div v-show="!isLoading" class="auth-form__wrapper">
        <div class="auth-form__forms">
          <PasswordResetForm
            class="auth-form__form"
            :isLoading="isLoading"
            @submit-form="submitForm"
          />
        </div>
        <AdditionalLinks
          :isTabletFooter="true"
          class="auth-form__form-footer-links"
        />
      </div>
      <Spinner
        v-show="isLoading"
        :label="'You’re being logged in'"
        class="auth-form__wrapper auth-form__spinner"
      />
    </div>
  </section>
</template>

<script>
import AuthenticationBackground from '@/components/forms/elements/AuthenticationBackground.vue'
import PasswordResetForm from '@/components/forms/PasswordResetForm.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'
import Spinner from '@/components/loaders/LoadingSpinnerV2.vue'

export default {
  name: 'ForgotPassword',
  metaInfo() {
    return {
      title: 'INE - Reset Password',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  components: {
    AuthenticationBackground,
    PasswordResetForm,
    AdditionalLinks,
    Spinner,
  },
  data() {
    return {
      isLoading: false,
      code: '',
      username: '',
      session: '',
    }
  },
  created() {
    this.handleParams(new URLSearchParams(window.location.search))
  },
  methods: {
    async submitForm({ password }) {
      const { code, username, session } = this
      this.isLoading = true
      if (code) {
        await this.$store.dispatch('auth/updateNewPasswordByCode', {
          code,
          username,
          password,
        })
      } else {
        await this.$store.dispatch('auth/updateNewPasswordBySession', {
          session,
          username,
          password,
        })
      }
      this.isLoading = false
    },
    handleParams(params) {
      const code = params.get('code')
      const username = params.get('username')
      const session = params.get('session')
      if (!username || (!code && !session)) {
        this.$router.push({ name: 'login' })
        this.$store.dispatch(
          'app/setError',
          'There was an error, please try again.'
        )
      } else {
        this.code = code
        this.username = username
        this.session = session
      }
    },
  },
}
</script>
